<template>
    <div class="abstract-con zhaiyao-bg card-bg-f1 primary-bd-ee primary-text-26" v-show="propsData.abstract">
        {{abstr}}
    </div>
</template>

<script>

export default {
    name: '',
    data() {
        return {
            model: {
                abstract: "上海自贸试验区的新一轮改革试验宣告正式开启。知情人士透露，新片区已在启动新的产业规划。摘要内容摘要内容摘要内容摘要内容摘要内容摘要内容摘要内容摘要内容摘要。"
            }
        }
    },
    props: {
        propsData: {
            type: Object,
            abstract: ""
        }
    },
    computed: {
        abstr() {
            return ("" + this.propsData.abstract).trim()
        }
    },
    beforeCreate: function () {
    },
    created: function () {
    },
    mounted: function () {
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
@import '../../common/style/common-color.less';

.abstract-con {
    box-sizing: border-box;
    width: 100%;
    padding: 8px 10px;
    margin-top: 20px;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    font-size: 16px;
    line-height: 32px;
    text-align: justify;
}
.zhaiyao-bg {
    background: #f8f8f8;
}
.night {
    .zhaiyao-bg {
        background: #333;
        border-color: #4c4c4c;
    }
}
</style>
